import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'
import { calendlyTokenLink, calendlyEventsLink } from '../Themes/constants'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  toggleBanner: ['show', 'title', 'content', 'action'],
  showInvalidCalendlyToken: [],
  showNoEvents: []
})

export const SelectionTypes = Types
export default Creators

/* ------------- Initial State ------------- */
export const INITIAL_STATE = Immutable({
  show: false,
  title: '',
  content: '',
  action: {},
  status: 'warning'
})

/* ------------- Reducers ------------- */

export const toggleBanner = (state, { show, title, content, action }) => {
  if (show) {
    return state.merge({ show, title, content, action: action || {} })
  } else {
    return state.merge({ show, title: '', content: '', action: {} })
  }
}

export const showInvalidCalendlyToken = state => {
  return state.merge({
    show: true,
    title: 'Invalid Calendly Token',
    content: 'Your calendly token is invalid. Please add a valid token',
    action: {
      content: 'Get Calendly Token',
      onAction: () => {
        window.open(calendlyTokenLink, '_blank')
      }
    }
  })
}

export const showNoEvents = state => {
  return state.merge({
    show: true,
    title: 'No Events',
    content:
      'Uh-oh, Looks like you have no events in your calendar. Get started by adding new events by clicking on the link below',
    action: {
      content: 'Create Calendly Event',
      onAction: () => {
        window.open(calendlyEventsLink, '_blank')
      }
    }
  })
}

/* ------------- Selectors ------------- */

export const SelectionSelectors = {}

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.TOGGLE_BANNER]: toggleBanner,

  [Types.SHOW_INVALID_CALENDLY_TOKEN]: showInvalidCalendlyToken,
  [Types.SHOW_NO_EVENTS]: showNoEvents
})
